import { Button, Classes, HTMLTable, Icon, Popover } from '@blueprintjs/core';
import moment from 'moment';
import React from 'react';
import { DATE_FORMAT, ERROR_TOAST_ICON, SHORT_TIME_FORMAT_24 } from '../../../utils/Constants';
import { arrowsIconTable, exceptionsDetailsField, htmlHeaderStyle, exceptionsTableStyles, flexRow, tablePopoverColors, tdPadding, tdPaxFirstName } from '../../styles';
import MenuExceptionTrip from '../menuComponents/menuExceptionTrip';
import OverlayConfirmProvider from '../modalComponents/overlayConfirmProvider';
import OverlayEmulateEvents from '../modalComponents/overlayEmulateEvents';
import AlertModal from '../modalComponents/alertModal'
import { resolveException, removeProvider, reserveException, reserveAllExceptions } from '../../services/tripApiService'
import { AppToaster } from "../../toastComponent";
import { sendDriverSms } from "../../services/smsApiService";
import { showDialysisIndicator, showVipIndicator, showWcIndicator } from './../../../utils/bizCommon';
import { reserveExceptionResponse } from './../../../utils/helpers';
import OverlayCancelTrip from '../modalComponents/overlayCancelTrip';

export default class ExceptionsTable extends React.Component {
  state = {
    isDialogClearException: false,
    isOverlayConfirmProvider: false,
    isDialogConfirmProvider: false,
    isDialogRemoveProvider: false,
    isOverlayEmulateEvents: false,
    isDialogSendSms: false,
    isOverlayConfirmTripCancellation: false,
    isDialogReserveException: false,
    isDialogCancelReservation: false,
    sortBy: 'CreatedOnUTC',
    sortOrder: 'ASC',
    trip: null,
  }

  getAge = (exception) => {
    const createdException = moment(exception.createdOnUTC);
    return moment().diff(createdException, 'minutes');
  }

  handleConfirmedMenuClick = async (event, exceptionId, tripNumber) => {
    const menuItemId = event.currentTarget.id;
    this.setState({
      [menuItemId]: true,
    })
    
    if (menuItemId === 'isDialogReserveException') {
      await this.reserveException(exceptionId);
      this.props.refreshExceptions(this.state.sortBy, this.state.sortOrder);
    }
    else if (menuItemId === 'isDialogReserveAllExceptions'){
      await this.reserveAllExceptions(exceptionId,tripNumber);
      this.props.refreshExceptions(this.state.sortBy, this.state.sortOrder);
    }
    else if (menuItemId === 'isDialogCancelReservation') {
      await this.cancelReservation(exceptionId);
      this.props.refreshExceptions(this.state.sortBy, this.state.sortOrder);
    }
  }

  handleSorting = (headerColumn) => {
    this.setState({
      sortBy: headerColumn,
      sortOrder: this.state.sortOrder === 'ASC' ? 'DESC' : 'ASC'
    }, () => this.props.refreshExceptions(this.state.sortBy, this.state.sortOrder));
  }

  onModalClosed = (id) => {
    this.setState({
      [id]: false,
    })
    this.props.refreshExceptions(this.state.sortBy, this.state.sortOrder)
  }

  resolveException = async (exception) => {
    try {
      await resolveException(exception.exceptionId, "resolve");
      AppToaster.show({ message: "Exception resolved.", intent: "success", icon: 'tick', });
    }
    catch (error) {
      console.log(error);
      AppToaster.show({ message: error.response.data, intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON, });
    }
  }

  reserveException = async (exceptionId) => {
    try {
      await reserveException(exceptionId, 'reserve');

      AppToaster.show({ message: "Exception reserved.", intent: "success", icon: 'tick', });
    }
    catch (error) {
      console.log(error.response);
      AppToaster.show({ message: reserveExceptionResponse(error.response.data) , intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON, });
    }
  }

  reserveAllExceptions = async (exceptionId,tripNumber) => {
    const data = {
      tripId: tripNumber, exceptionId: exceptionId,
    }
    try {
      const response = await reserveAllExceptions(data);
      AppToaster.show({ message: response.data + " exceptions reserved.", intent: "success", icon: 'tick', });
    }
    catch (error) {
      console.log(error);
      AppToaster.show({ message: reserveExceptionResponse(error.response.data), intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON, });
    }
  }

  cancelReservation = async (exceptionId) => {
    try {
      await reserveException(exceptionId, 'cancelreservation');

      AppToaster.show({ message: "Exception unreserved.", intent: "success", icon: 'tick', });
    }
    catch (error) {
      console.log(error);
      AppToaster.show({ message: error.response.data, intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON, });
    }
  }

  removeProvider = async (tripNumber) => {
    try {
      await removeProvider(tripNumber);

      AppToaster.show({ message: `Provider removed from trip: ${tripNumber}.`, intent: "success", icon: 'tick', });
    }
    catch (error) {
      console.log(error);
      AppToaster.show({ message: error.response.data, intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON, });
    }
  }

  sendDriverSms = async (tripNumber) => {
    try {
      await sendDriverSms(tripNumber);

      AppToaster.show({ message: 'SMS has been sent.', intent: "success", icon: 'tick', });
    }
    catch (error) {
      console.log(error);

      AppToaster.show({ message: error.response.data, intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON, });
    }
  }
  render() {
    const headers = [
      { name: 'Due Date', column: 'DueTime' },
      { name: 'Due Time', column: 'DueTime' },
      { name: 'Trip Status', column: 'TripStatus' },
      { name: 'First Name', column: 'PassengerFirstName' },
      { name: 'Last Name', column: 'PassengerLastName' },
      { name: 'Serv. Level', column: 'ServiceLevelName' },
      { name: 'Client', column: 'ClientName' },
      { name: 'Service Provider', column: 'ServiceProviderName' },
      { name: 'State', column: 'PuState' },
      { name: 'Exception', column: 'Name' },
      { name: 'Exception Details', column: 'Details' },
      { name: 'Age', column: 'CreatedOnUTC' },
      { name: 'Reserved by', column: 'ReservedBy' },
    ];

    return (
      <>
        <HTMLTable bordered condensed interactive style={exceptionsTableStyles}>
          <thead>
            <tr>
              {headers.map(header => {
                return (
                  <th key={header.name} style={htmlHeaderStyle(this.props.themeName === Classes.DARK)} onClick={() => this.handleSorting(header.column)}>
                    {header.name}
                    <Icon style={arrowsIconTable} icon={'double-caret-vertical'} iconSize={13} />
                  </th>
                );
              })}
              <th style={htmlHeaderStyle(this.props.themeName=== Classes.DARK)} ></th>
            </tr>
          </thead>
          <tbody id='exception-table'>
            {this.props.exceptions.map(exception => (
              <tr key={exception.exceptionId} id={exception.exceptionId} onClick={this.props.setSelectedException}>
                <td style={tdPadding}>{moment.tz(exception.dueDateTime, exception.pickupTimeZone).format(`${DATE_FORMAT}`)}</td>
                <td style={tdPadding}>
                  <div style={flexRow}>
                    {moment.tz(exception.dueDateTime, exception.pickupTimeZone).format(`${SHORT_TIME_FORMAT_24} z`)}&nbsp;
                  {showVipIndicator(exception.isVip)}
                  </div>
                </td>
                <td style={tdPadding}>{exception.tripStatus}</td>
                <td style={tdPaxFirstName}>
                  <div style={flexRow}>
                    {exception.passengerFirstName}&nbsp;
                    {showDialysisIndicator(exception.customFields)}
                  </div>
                </td>
                <td style={tdPadding}>{exception.passengerLastName}</td>
                <td style={tdPadding}>
                  <div style={flexRow}>
                    {exception.serviceLevel}&nbsp;
                    {showWcIndicator(exception.wheelchairType)}
                  </div>
                </td>
                <td style={tdPadding}>{exception.clientName}</td>
                <td style={tdPadding}>{exception.serviceProviderName}</td>
                <td style={tdPadding}>{exception.pickupState}</td>
                <td style={tdPadding}>{exception.exceptionTypeName}</td>
                <td style={exceptionsDetailsField}>{exception.details}</td>
                <td style={tdPadding}>{this.getAge(exception)}</td>
                <td style={tdPadding}>{exception.reservedByUser}</td>
                <td style={tdPadding}>
                  <Popover style={tablePopoverColors}
                    content={
                      <MenuExceptionTrip
                        tripStatus={exception.tripStatus}
                        reservedByMe={exception.reservedByMe}
                        reservedByUser={exception.reservedByUser}
                        exceptionId={exception.exceptionId}
                        tripNumber = {exception.tripNumber}
                        handleConfirmedMenuClick={this.handleConfirmedMenuClick} />}>
                    <Button small icon="menu-open" />
                  </Popover>
                </td>
              </tr>
            ))}
          </tbody>
        </HTMLTable>
        {this.state.isDialogClearException && this.props.selectedException && (
          <AlertModal id={'isDialogClearException'}
            icon={'small-cross'}
            message='Are you sure you want to resolve exception?'
            onModalClosed={this.onModalClosed}
            onConfirm={() => this.resolveException(this.props.selectedException)} />
        )
        }
        {this.state.isOverlayConfirmProvider && (
          <OverlayConfirmProvider id={'isOverlayConfirmProvider'} trip={this.props.selectedTrip} isSelectNewDriver={false} onModalClosed={this.onModalClosed} />
        )
        }

        {this.state.isDialogRemoveProvider && (
          <AlertModal id={'isDialogRemoveProvider'}
            message={`Are you sure you want to remove the provider from Trip ${this.props.selectedTrip.tripNumber}?`}
            onModalClosed={this.onModalClosed}
            onConfirm={() => this.removeProvider(this.props.selectedTrip.tripNumber)} />
        )
        }
        {this.state.isOverlayEmulateEvents && this.props.selectedTrip !== null && (
          <OverlayEmulateEvents id={'isOverlayEmulateEvents'} trip={this.props.selectedTrip} onModalClosed={this.onModalClosed} />
        )
        }
        {this.state.isDialogSendSms && (
          <AlertModal id={'isDialogSendSms'}
            message='Are you sure you want to send a SMS?'
            icon='arrow-top-right'
            intent='warning'
            onModalClosed={this.onModalClosed}
            onConfirm={() => this.sendDriverSms(this.props.selectedTrip.tripNumber)} />
        )
        }
        {this.state.isOverlayConfirmTripCancellation && (
          <OverlayCancelTrip
            id={'isOverlayConfirmTripCancellation'}
            tripNumber={this.props.selectedTrip?.tripNumber}
            message={`Are you sure you want to cancel Trip ${this.props.selectedTrip?.tripNumber}?`}
            onModalClosed={this.onModalClosed}
          />
        )
        }
      </>
    )
  }
}
